/**
 * Write your JS code here for frontend.
 */
/* eslint-disable no-console */
console.log( 'Hello from Features Plugin' );
/* eslint-enable no-console */
